module.exports = __webpack_public_path__ + "static/media/cleaningIcon.06dbfaec.svg";